import { LanguageInterface } from "../interfaces/shared/LanguageInterface";

export const Translate = (
    texts: Record<string, string> | undefined | null,
    activeLanguage: LanguageInterface | undefined | null,
): string => {
    const activeLanguageKey = activeLanguage?.localeCode;

    if (activeLanguageKey && texts && texts[activeLanguageKey]) {
        return texts[activeLanguageKey];
    }

    return "Missing translations for language: " + activeLanguageKey;
};
